import React, { useEffect } from 'react'
import { jsx } from 'theme-ui'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { get } from 'lodash'

import Header from '../components/header'

import Global from '../styles/global'

export default connect(state => {
  return {}
})(props => {
  const { children } = props

  return <React.Fragment>
    <Global />
    <Header />
    {children}
  </React.Fragment>
})
